import firebase from 'firebase/compat/app';

export const callGetLoanDocumentsGCPFunction = async (loanId: string): Promise<any> => {
  const functions = firebase.functions();
  const getLoanDocuments = functions.httpsCallable('getLoanDocuments');
  const result = await getLoanDocuments({ firestoreLoanId: loanId });
  return result.data;
};
